import React, {
  useEffect, useMemo,
} from 'react'
import { Form, Formik } from 'formik'
import { useDispatch, useSelector } from 'react-redux'

import { FieldFormik } from '@src/components/FieldFormik/FieldFormik'
import { selectProfile } from '@src/store/ducks/user/selectors'
import { AppDispatch } from '@src/store/store'
import { getProfile } from '@src/store/ducks/user/thunks'
import style from '@src/pages/Profile/Profile.module.scss'
import { CheckBoxContainer } from '@src/components/CheckBoxContainer/CheckBoxContainer'
import * as Yup from 'yup'
import { birthday, email } from '@src/lib/regex'
import { validateForm } from '@src/messages/validateForm'
import moment from 'moment'
import cn from 'classnames'

export const Profile = () => {
  const dispatch = useDispatch<AppDispatch>()
  const profile = useSelector(selectProfile)
  const dateRegex = /^\d{4}-\d{2}-\d{2}$/
  const formatDateToDisplay = (date: any) => {
    if (dateRegex.test(date)) {
      return moment(date, 'YYYY-MM-DD').format('DD-MM-YYYY')
    }
    // Если дата уже в формате DD-MM-YYYY или другом формате, возвращаем ее без изменений
    console.log('Date is not in YYYY-MM-DD format, returning as is:', date)
    return date
  }

  useEffect(() => {
    dispatch(getProfile())
  }, [dispatch])
  const validationSchema = useMemo(() => (
    Yup.object().shape({
      email: Yup.string()
        .matches(email, validateForm.email)
        .required(validateForm.email),
      birthday: Yup.string()
        .matches(birthday, validateForm.birthday)
        .test('lastBirthdayUpdate', `Редактирование даты рождения допускается не чаще 1 раза в год <br> Последняя смена даты рождения ${moment(profile.lastBirthdayUpdate).format('DD-MM-YYYY')}`, () => !moment(profile.lastBirthdayUpdate).add(1, 'year').isAfter(moment()))
        .required(validateForm.birthday),
    })
  ), [profile.lastBirthdayUpdate])

  const initialValues = useMemo(() => ({
    surname: profile.surname,
    name: profile.name,
    patronymic: profile.patronymic,
    birthday: formatDateToDisplay(profile.birthday),
    phone: profile.phone,
    locality: profile.locality,
    email: profile.email,
    cardNumber: profile.cardNumber.map((card) => card.number),
    isPromotionalGames: profile.isPromotionalGames,
    isPoll: profile.isPoll,
    isPromotionalMail: profile.isPromotionalMail,
    isProcessingPersonalData: profile.isProcessingPersonalData,
    isLoyalty: profile.isLoyalty,
    gender: profile.gender,
    getSms: profile.getSms,
    isPollsConsent: profile.isPollsConsent,
  }), [profile])
  // const handleSaveField = useCallback((e) => {
  //   dispatch(setField(e.target.name, e.target.value))
  // }, [dispatch])

  return (
    <div>
      <Formik
        initialValues={initialValues}
        onSubmit={() => {
        }}
        enableReinitialize
        validationSchema={validationSchema}
      >
        {() => (
          <Form className={style.form}>
            <div className={style.form_container}>
              <div className={style.required}>*</div>
              <FieldFormik
                name="phone"
                placeholder="Номер телефона"
                mask="+{375} (00) 000-00-00"
                outline
                disabled
                className={style.disabled}
              />
              <div className={style.required}>*</div>
              <FieldFormik
                name="surname"
                placeholder="Фамилия"
                outline
                isEdit
              />
              <div className={style.required}>*</div>
              <FieldFormik
                name="name"
                placeholder="Имя"
                outline
                isEdit
              />
              <div className={style.required}>*</div>
              <FieldFormik
                name="patronymic"
                placeholder="Отчество"
                outline
                isEdit
              />
              <div className={style.required}>*</div>
              <FieldFormik
                name="birthday"
                mask="00-00-0000"
                placeholder="Дата рождения в формате дд-мм-гггг"
                outline
                isEdit
              />
              {/* <FieldFormik */}
              {/*  name="locality" */}
              {/*  placeholder="Город" */}
              {/*  outline */}
              {/*  isEdit */}
              {/* /> */}
              {/* <FieldFormik */}
              {/*  name="email" */}
              {/*  placeholder="Email" */}
              {/*  outline */}
              {/*  isEdit */}
              {/* /> */}

              <div className={cn(style.required, style.cardStar)}>*</div>
              {initialValues.cardNumber.map((el, index) => (
                <FieldFormik
                  key={el}
                  disabled
                  name={`cardNumber[${index}]`}
                  placeholder="Номер карты"
                  outline
                  className={style.disabled}
                />
              ))}
            </div>
            {/* Выбор пола */}
            {/* <div className={cn(style.fieldPosition, style.chooseGender)}> */}
            {/*  <div className={style.title}>Ваш пол:</div> */}
            {/*  <CheckBoxFormik */}
            {/*    onChange={handleSaveField} */}
            {/*    className={style.radioSize} */}
            {/*    label="Мужской" */}
            {/*    name="gender" */}
            {/*    type="radio" */}
            {/*    value="male" */}
            {/*    checked={profile.gender === 'male'} */}
            {/*  /> */}
            {/*  <CheckBoxFormik */}
            {/*    onChange={handleSaveField} */}
            {/*    className={style.radioSize} */}
            {/*    label="Женский" */}
            {/*    name="gender" */}
            {/*    type="radio" */}
            {/*    value="female" */}
            {/*    checked={profile.gender === 'female'} */}
            {/*  /> */}
            {/* </div> */}
            <div className="bottom-dotted-lk-line" />
            <CheckBoxContainer
              className={style.checkBoxContainer}
              name="isPromotionalMail"
              description={(
                <span>
                  Я даю
                  <a
                    className={style.link}
                    href="/assets/pdf/03-5___1.pdf"
                    target="_blank"
                  >
                    {' '}
                    согласие
                    {' '}
                  </a>
                  на обработку моих персональных данных для информирования о товарах,
                  акциях и иных мероприятиях посредством рассылки SMS-сообщений, сообщений в мессенджерах.
                </span>
                )}
            />
            <CheckBoxContainer
              className={style.checkBoxContainer}
              name="isPoll"
              description={(
                <span>
                  Я даю
                  <a
                    className={style.link}
                    href="/assets/pdf/03-7___1.pdf"
                    target="_blank"
                  >
                    {' '}
                    согласие
                    {' '}
                  </a>
                  на обработку моих персональных данных для проведения опросов,
                  статистических и маркетинговых исследований.
                </span>
                )}
            />
            <CheckBoxContainer
              className={style.checkBoxContainer}
              name="isPromotionalGames"
              description={(
                <span>
                  Я даю
                  <a
                    className={style.link}
                    href="/assets/pdf/03-4___1.pdf"
                    target="_blank"
                  >
                    {' '}
                    согласие
                    {' '}
                  </a>
                  на обработку моих персональных данных для обеспечение моего участия в
                  рекламных акциях и играх.
                </span>
                )}
            />

            {/* <div className="bottom-dotted-lk-line" /> */}

            {/* <CheckBoxContainer */}
            {/*  name="isPromotionalGames" */}
            {/*  description={( */}
            {/*    <div> */}
            {/*      Я подтверждаю корректность данных и даю */}
            {/*      {' '} */}
            {/*      <a target="_blank" href="/assets/pdf/03-4_Согласие_рекламные_акции_игры_20_07_23.pdf">согласие</a> */}
            {/*      {' '} */}
            {/*      на обработку моих персональных данных для моего участия в рекламных акциях и играх */}
            {/*    </div> */}
            {/*  )} */}
            {/*  className={style.checkBoxContainer} */}
            {/* /> */}
            {/* <CheckBoxContainer */}
            {/*  name="getSms" */}
            {/*  description={( */}
            {/*    <div> */}
            {/*      Я даю */}
            {/*      {' '} */}
            {/*      <a target="_blank" href="/assets/pdf/03-5_Согласие_рекламная_рассылка_20_07_23.pdf">согласие</a> */}
            {/*      {' '} */}
            {/*      на обработку моих персональных данных для получения информации о товарах, акциях и иных мероприятиях посредством рассылки */}
            {/*    </div> */}
            {/*  )} */}
            {/*  className={style.checkBoxContainer} */}
            {/* /> */}
            {/* <CheckBoxContainer */}
            {/*  name="isPollsConsent" */}
            {/*  description={( */}
            {/*    <div> */}
            {/*      Я даю */}
            {/*      {' '} */}
            {/*      <a target="_blank" href="/assets/pdf/03-7_Согласие_опросы_20_07_23.pdf">согласие</a> */}
            {/*      {' '} */}
            {/*      на обработку моих персональных данных для проведения опросов, статистических и маркетинговых исследований */}
            {/*    </div> */}
            {/*  )} */}
            {/*  className={style.checkBoxContainer} */}
            {/* /> */}
            {/* <div className={style.note}>Согласие с пунктами, перечисленными ниже, дают Вам право воспользоваться скидками, бонусными баллами и иными предложениями в рамках программы лояльности «Дионис – польза очеВидна!»</div> */}
            {/* <CheckBoxContainer */}
            {/*  // name="loyal" */}
            {/*  name="isLoyalty" */}
            {/*  description={( */}
            {/*    <div> */}
            {/*      {' '} */}
            {/*      Я понимаю и полностью принимаю условия */}
            {/*      <a target="_blank" href="/loyalty"> участия в программе лояльности «Дионис – польза очеВидна!»</a> */}
            {/*    </div> */}
            {/*  )} */}
            {/*  className={style.checkBoxContainer} */}
            {/*  disabled */}
            {/* /> */}
            {/* <CheckBoxContainer */}
            {/*  name="isProcessingPersonalData" */}
            {/*  // name="isPromotionalGames" */}
            {/*  description={( */}
            {/*    <div> */}
            {/*      «Я даю */}
            {/*      {' '} */}
            {/*      <a target="_blank" href="/assets/pdf/03-6_Согласие_Программа_лояльности_20_07_23.pdf">согласие</a> */}
            {/*      {' '} */}
            {/*      на обработку моих персональных данных для обеспечение моего участия в программе лояльности «Дионис – польза очеВИДНА! */}
            {/*    </div> */}
            {/*  )} */}
            {/*  className={style.checkBoxContainer} */}
            {/*  disabled */}
            {/* /> */}

            {/* <div className={style.noteRevoke}> */}
            {/*  Отозвать согласие можно направив обращение на адрес электронной почты */}
            {/*  {' '} */}
            {/*  <a href="mailto:call.center@resttrade.by">call.center@resttrade.by</a> */}
            {/*  . Запрос обрабатывается в течение 15 рабочих дней. Отзыв согласия предусматривает приостановку участия в программе лояльности «Дионис – польза очеВидна!», а также в рекламных мероприятиях, проводимых ООО «Ресттрэйд» */}
            {/* </div> */}

          </Form>
        )}
      </Formik>
    </div>
  )
}
